import { render, staticRenderFns } from "./wechat-category-dialog.vue?vue&type=template&id=6af4ecdc&"
import script from "./wechat-category-dialog.vue?vue&type=script&lang=js&"
export * from "./wechat-category-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports